import Bugsnag from "@bugsnag/js";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import { useBreakpoint } from "@Hooks/useBreakpoint";
import { ReactComponent as IconArrowRight } from "@Icons/16x16/arrow-right.svg";
import { Tile } from "@Types/pagify";
import { getLink } from "@Utils/pagify";
import { setDataLayerTrack } from "@Utils/track";
import "./style.scss";

export const HomeHeroItem: FunctionComponent<{
  tiles: Tile[];
  type: "small" | "large";
}> = ({ tiles, type }) => {
  const intl = useIntl();
  const localeSlug = intl.locale;

  const tile = tiles[0];
  const tileTitle = tile.textBlock1 && tile.textBlock1[0].text;
  const tileSubtitle = tile.textBlock2 && tile.textBlock2[0].text;
  const tileCta = tile.cta;
  const tileImage = tile.images.length > 0 && tile.images[0].desktop;

  const { isSmallScreen, isMediumScreen } = useBreakpoint();

  if (!tileImage) {
    Bugsnag.notify(new Error(`image for tile ${tile.slug} not found in HomeHeroItem`));
    return null;
  } else if (!tileCta) {
    Bugsnag.notify(new Error(`CTA for tile ${tile.slug} not found in HomeHeroItem`));
    return null;
  }

  const link = getLink(tileCta.navigationLink, localeSlug);

  const handleClick = () => {
    setDataLayerTrack("Promotion Clicked", {
      category: "HomePage",
      message: tileCta.text || tile.slug,
      position: "web_home_button",
    });
  };

  return (
    <div className={`HomeHeroItem HomeHeroItem-${type}`}>
      <div className="HomeHeroItem-content">
        <div className="HomeHeroItem-content-title">{tileTitle}</div>
        <div className="HomeHeroItem-content-subtitle">{tileSubtitle}</div>
        <ButtonSmily
          href={link}
          icon={<IconArrowRight />}
          iconPosition="right"
          onClick={handleClick}
          size={isMediumScreen && !isSmallScreen ? "xs" : "s"}
          type="primary"
        >
          {tileCta.text}
        </ButtonSmily>
      </div>
      <a className="HomeHeroItem-link" href={link} onClick={handleClick} />
      <img
        alt={tileTitle || ""}
        className="HomeHeroItem-image"
        height={type === "large" ? 490 : 542}
        src={tileImage["1x"]}
        srcSet={`${tileImage["1x"]} 1x, ${tileImage["2x"]} 2x`}
        width={type === "large" ? 856 : 520}
      />
    </div>
  );
};
